export default __webpack_public_path__ + "static/media/icon-drag.f62c57f1.svg";